// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2QI3X","footer":"Form_footer__1eo-O"};